import { PapiDeviation } from '@wix/da-papi-types';
import { AppState } from '../../types/store';
import MediaService from '@wix/da-shared-react/pkg/utils/DeviationMediaService';
import { getModuleDataByModuleType as getModuleDataByModuleTypeNewGrusers } from '@wix/da-gruser-shared/pkg/redux/selectors/modules';

import { getModuleDataByModuleType } from './modules';
import { ModuleType } from '../../types/modules';
import { getProfileGruser } from './users';
import { isNewGrusersActive } from './sections';

export const getCoverDeviationLegacy = state => {
  const coverDeviation = (
    getModuleDataByModuleType(state, ModuleType.COVER_DEVIATION) || {}
  ).coverDeviation;
  return coverDeviation;
};

export const getCoverDeviation = (
  state: AppState
): PapiDeviation | undefined => {
  // the fallback is needed for when the user XHR-switches
  // from a ported section to a non-ported one and vica-versa
  if (isNewGrusersActive(state)) {
    return getCoverDeviationNewGrusers(state) || getCoverDeviationLegacy(state);
  }
  return getCoverDeviationLegacy(state) || getCoverDeviationNewGrusers(state);
};

export const getCoverDeviationNewGrusers = (
  state: AppState
): PapiDeviation | undefined => {
  const coverDeviation = (
    getModuleDataByModuleTypeNewGrusers(
      state as any,
      getProfileGruser(state),
      ModuleType.COVER_DEVIATION
    ) || {}
  ).coverDeviation;

  return coverDeviation || undefined;
};

export const getCoverDeviationOffsetY = (state: AppState): number => {
  const coverDeviationidOffsetY =
    (getModuleDataByModuleType(state, ModuleType.COVER_DEVIATION) || {})
      .coverDeviationidOffsetY || 0;
  return coverDeviationidOffsetY;
};

export const getDeviationFileSrc = (
  deviation: PapiDeviation,
  fileType: string
) => {
  const deviationFile = MediaService.getDeviationFile(deviation, fileType);
  return (deviationFile && deviationFile.src) || '';
};
